import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const SlaCompliance = ({ data }) => {
  if (!data) return null;

  const chartData = {
    labels: ["Compliant", "Breached"],
    datasets: [
      {
        data: [data.compliant || 0, data.breached || 0],
        backgroundColor: ["#5A9559", "#D32F2F"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "65%",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: { size: 12 },
          color: "#6b778c",
          padding: 16,
        },
      },
    },
  };

  const complianceRate = data.compliant + data.breached > 0
    ? Math.round((data.compliant / (data.compliant + data.breached)) * 100)
    : 0;

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      }}
    >
      <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#172b4d", mb: 2 }}>
        SLA Compliance
      </Typography>
      <Box sx={{ position: "relative", height: 220, display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: 200, height: 200 }}>
          <Doughnut data={chartData} options={options} />
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontSize: 28, fontWeight: 600, color: "#172b4d" }}>
            {complianceRate}%
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

SlaCompliance.propTypes = {
  data: PropTypes.object,
};

export default SlaCompliance;
